export default {
  "nonArrivalTicketRecord.th.logId": "ログID",
  "nonArrivalTicketRecord.th.operationDateAndTime": "操作日時",
  "nonArrivalTicketRecord.th.showDateAndTime": "上映日時",
  "nonArrivalTicketRecord.th.showTime": "開始時間",
  "nonArrivalTicketRecord.th.ticketType": "券種",
  "nonArrivalTicketRecord.th.qty": "枚数",
  "nonArrivalTicketRecord.th.boxOfficeRevenueAmount": "興行収入計上金額",
  "nonArrivalTicketRecord.th.device": "デバイス",
  "nonArrivalTicketRecord.th.manager": "担当者",
  "nonArrivalTicketRecord.th.comment": "コメント",

  "nonArrivalTicketRecord.createRecord": "作成",

  /** create record dialog */
  "nonArrivalTicketRecord.dialog.title": "未着券計上",
  "nonArrivalTicketRecord.dialog.formField.upcomingDate": "上映日付",
  "nonArrivalTicketRecord.dialog.formField.showTime": "上映日時",
  "nonArrivalTicketRecord.dialog.formField.ticketType": "全国共通券/劇場前売券",
  "nonArrivalTicketRecord.dialog.formField.qty": "枚数",
  "nonArrivalTicketRecord.dialog.formField.device": "デバイス",
  "nonArrivalTicketRecord.dialog.formField.comment": "コメント",
  "nonArrivalTicketRecord.dialog.formField.selectPlaceHolder": "選択してください",
  "nonArrivalTicketRecord.dialog.formField.inputPlaceHolder": "入力してください",
};